import React, { useState } from 'react'
import axios from 'axios'
const url = process.env.REACT_APP_API_BASE_URL

export const DashboardApi = () => {
    
      const response = axios.get(`${url}/api/v1/dashboard/stats/`)
      return response;
}

export const ReportSourceApi = (data) =>{
  const response = axios.get(`${url}/api/v1/report${data}`)
  return response;
}

export const callReportSourceApi = (data)=>{
  const response = axios.get(`${url}/api/v1/events${data}`)
  return response;
}
